import { Component, Input } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipDirective } from '../../../directives/tooltip.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClickStopPropagationDirective } from '../../../directives/stop-propagation.directive';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-input-field',
    templateUrl: './input-field.component.html',
    standalone: true,
    imports: [NgIf, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, ClickStopPropagationDirective, MatTooltipModule, TooltipDirective, TranslateModule]
})
export class InputFieldComponent {
    @Input() placeholder: string;
    @Input() control: AbstractControl;
    @Input() required = false;
    @Input() icon: string;
    @Input() tooltip: string;
    @Input() id = '';
    @Input() hint: string;
    @Input() autocomplete = 'off';
    @Input() type = 'search';
}
